import React, { useEffect, useState } from "react";
import "./solarCal.css";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  getSolarCal,
  getSolarCalfield,
} from "components/Service/SolarcalcultionApi";
import { API_BASE_CMS } from "helper/environment";
import VoltageSliderMUI from "./voltageMUI";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
interface Results {
  system: string;
  monthly: string;
  yearly: string;
  co2: string;
}
interface ErrorType {
  state: string;
  captive: string;
  voltage: string;
    nonPeak: string;
    peak: string;
    nonBusbar: string;
    peakBusbar: string;
}
const UUID = "74af3cce-e569-4983-9dbe-a7d0c2f16264";

const SolarCalculator: React.FC = () => {
  const [data, setData] = useState<any | null>(null);
  const [detail, setDetail] = useState<any | null>(null);
  const [caldetail, setCalList] = useState<any | null>(null);
  const [sId, setSid] = useState<string | null>(null);
  const [calculation, setCalculation] = useState([
    { label: "Solar/Non-Peak OA Landed (Rs./kWh)", value: "", icon: "" },
    { label: "Evening/Peak OA Landed (Rs./kWh)", value: "", icon: "" },
    { label: "Solar/Non-Peak DISCOM Landed (Rs./kWh)", value: "", icon: "" },
    { label: "Evening/Peak DISCOM Landed (Rs./kWh)", value: "", icon: "" },
    { label: "Solar / Non-Peak Savings (Rs./kWh)", value: "", icon: "" },
    { label: "Evening / Peak Savings (Rs./kWh)", value: "", icon: "" },
  ]);
  const [error, setError] = useState<string | null>(null);
  const [retry, setRetry] = useState(0);
  const [selectedVoltage, setSelectedVoltage] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isState, setIsShowState] = useState(false);
  const [isShowDiv, setIsShowDiv] = useState<number>(1);

  const [errorcal, setErrorcal] = useState<ErrorType>({
    state: "",
    captive: "",
    voltage: "",
    nonPeak: "",
    peak: "",
    nonBusbar: "",
    peakBusbar: "",
  });

  useEffect(() => {
    const loadPrimary = async () => {
      try {
        // ✅ FIRST API (blocking / important)
        const datalistfield = await getSolarCalfield(UUID);
        setDetail(datalistfield);

        // ✅ AFTER FIRST API → trigger second in background
        loadSecondary();
      } catch (e: any) {
        setError(e.message || "Failed to load primary data");

        setTimeout(() => {
          setRetry((prev) => prev + 1);
        }, 10000);
      }
    };

    const loadSecondary = async () => {
      try {
        // ✅ SECOND API (background)
        const datalist = await getSolarCal();

        const cleanedData = datalist
        .map((item: any) => item?.attributes || {})   // extract attributes
        .sort((a:any, b:any) => {                             // sort by title
          if (!a.title) return 1;                      // handle missing title
          if (!b.title) return -1;
          return a.title.localeCompare(b.title);      // A → Z
        });

        setData(cleanedData);
      } catch (e: any) {
        console.error("Background API failed", e);
      }
    };

    loadPrimary();
  }, [retry]);

  const voltageLevels = detail?.data?.attributes?.field_voltage_level?.map((val: any) =>
      Math.round(Number(val)),
    ) || [];

  const NameField = detail?.formfield?.find((f: any) => f.name === "name");

  const emailField = detail?.formfield?.find((f: any) => f.name === "email");

  const mobileField = detail?.formfield?.find((f: any) => f.name === "mobile");

  const stateField = detail?.formfield?.find((f: any) => f.name === "state");

  const organizationField = detail?.formfield?.find(
    (f: any) => f.name === "organization",
  );

  const captiveField = detail?.formfield?.find(
    (f: any) => f.name === "captive-party",
  );

  const voltageField = detail?.formfield?.find(
    (f: any) => f.name === "voltage-level",
  );

  const nonpeakField = detail?.formfield?.find(
    (f: any) => f.name === "solar-non-peak-annual-energy-req",
  );

  const eveningpeakField = detail?.formfield?.find(
    (f: any) => f.name === "evening-peak-annual-energy-req",
  );

  const nonbusbarField = detail?.formfield?.find(
    (f: any) => f.name === "solar-non-peak-busbar-tariff",
  );

  const eveningbusbarField = detail?.formfield?.find(
    (f: any) => f.name === "evening-peak-busbar-tariff",
  );
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    state: "",
    captive: "",
    voltage: "",
    nonPeak: "",
    peak: "",
    nonBusbar: "",
    peakBusbar: "",
    organization: "",
  });
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "mobile") {
      // allow empty (so user can delete)
      if (value === "") {
        setFormData((prev) => ({ ...prev, mobile: value }));
        return;
      }

      // allow only digits
      if (!/^\d*$/.test(value)) return;

      // max 10 digits
      if (value.length > 10) return;

      // first digit must be 6-9 (only when length >= 1)
      if (value.length >= 1 && !/^[6-9]/.test(value)) return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const validateForm = () => {
    const newErrors = {
      name: "",
      email: "",
      mobile: "",
    };

    if (!formData.name.trim()) {
      newErrors.name = "Please enter your Full Name";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      newErrors.name = "Please enter valid Full Name";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Please enter your Email Address";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Please enter your Mobile Number";
    } else if (!/^[6-9][0-9]{9}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile Number must be exactly 10 digits";
    }

    setErrors(newErrors);

    return Object.values(newErrors).every((error) => error === "");
  };
  useEffect(() => {
    if (voltageLevels.length > 0 && !formData.voltage) {
      setFormData((prev) => ({
        ...prev,
        voltage: voltageLevels[0],
      }));
    }
  }, [voltageLevels]);
  const CalculForm = () => {
    const newErrorsCal = {
      state: "",
      captive: "",
      voltage: "",
      nonPeak: "",
      peak: "",
      nonBusbar: "",
      peakBusbar: "",
    };

    if (!formData?.state) {
      newErrorsCal.state = "Please select a state";
    }

    if (!formData?.captive) {
      newErrorsCal.captive = "Please select Type";
    }

    if (!formData?.voltage) {
      newErrorsCal.voltage = "Please select voltage level";
    }
    if (!formData?.nonPeak) {
      newErrorsCal.nonPeak = "Please enter a solar/non-peak annual energy requirement (kWh)";
    }

    if (!formData?.peak) {
      newErrorsCal.peak = "Please enter a Evening/peak annual energy requirement (kWh)";
    }

    if (!formData?.nonBusbar) {
      newErrorsCal.nonBusbar = "Please enter a solar/non-peak busbar tariff (Rs./kWh)";
    }
    if (!formData?.peakBusbar) {
      newErrorsCal.peakBusbar = "Please enter a evening/peak busbar tariff (Rs./kWh)";
    }

    setErrorcal(newErrorsCal);

    return Object.values(newErrorsCal).every((error) => error === "");
  };
  const [open, setOpen] = React.useState(false);
   const [openState, setOpenState] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseState = () => {
    setOpenState(false);
    resetForm();
  };

  const calculate = () => {
    setErrorcal({
      state: "",
      captive: "",
      voltage: "",
      nonPeak: "",
      peak: "",
      nonBusbar: "",
      peakBusbar: "",
    });

    const isValid = CalculForm();
 
    if (!isValid) return;
    //console.log(formData);
    const calList = data.find((f: any) => f.title === formData?.state);
    if(!calList.field_ht_tariff){
      //setOpenState(true);
      setIsShowState(true)
      return;
    }
    
    setCalList(calList);
    if (!calList) return;

    const updated = calculation.map((cal: any, i: any) => {
      let total = 0;
      if (cal.label === "Solar/Non-Peak OA Landed (Rs./kWh)" && calList) {
        let TransmissionLoss = Number(calList.field_transmission_loss || 0);
        let NonBusbar = Number(formData.nonBusbar || 0);
        let TransmissionCharges = Number(
          calList.field_transmission_charges || 0,
        );
        let WheelingLoss = Number(calList.field_wheeling_loss || 0);
        let WheelingCharges = Number(calList.field_wheeling_charges || 0);
        let SOCCharges = Number(calList.field_scheduling_soc_charges || 0);
        let Tax = Number(calList.field_tax || 0);
        let BankingCharges = Number(calList.field_banking_charges || 0);
        let SubsidySurcharge = Number(
          calList.field_cross_subsidy_surcharge || 0,
        );
        let AdditionalSurcharge = Number(
          calList.field_additional_surcharge || 0,
        );
        SubsidySurcharge =
          formData.captive === "3rd Party" ? SubsidySurcharge : 0;
        AdditionalSurcharge =
          formData.captive === "3rd Party" ? AdditionalSurcharge : 0;
        WheelingLoss = Number(formData.voltage) <= 33 ? WheelingLoss : 0;
        WheelingCharges = Number(formData.voltage) <= 33 ? WheelingCharges : 0;
        let loss = 0;
        let WheeLoss = 0;
        if (TransmissionLoss) {
          loss = TransmissionLoss / 100;
        }
        if (WheelingLoss) {
          WheeLoss = WheelingLoss / 100;
        }

        total =
          loss * NonBusbar +
          TransmissionCharges +
          WheeLoss * NonBusbar +
          WheelingCharges +
          SOCCharges +
          Tax +
          BankingCharges +
          NonBusbar +
          SubsidySurcharge +
          AdditionalSurcharge;

        //calculation[i].value = total.toString();
      } else if (cal.label === "Evening/Peak OA Landed (Rs./kWh)" && calList) {
        let TransmissionLoss = Number(calList.field_transmission_loss || 0);
        let NonBusbar = Number(formData.peakBusbar || 0);
        let TransmissionCharges = Number(
          calList.field_transmission_charges || 0,
        );
        let WheelingLoss = Number(calList.field_wheeling_loss || 0);
        let WheelingCharges = Number(calList.field_wheeling_charges || 0);
        let SOCCharges = Number(calList.field_scheduling_soc_charges || 0);
        let Tax = Number(calList.field_tax || 0);
        let BankingCharges = Number(calList.field_banking_charges || 0);
        let SubsidySurcharge = Number(
          calList.field_cross_subsidy_surcharge || 0,
        );
        let AdditionalSurcharge = Number(
          calList.field_additional_surcharge || 0,
        );
        SubsidySurcharge =
          formData.captive === "3rd Party" ? SubsidySurcharge : 0;
        AdditionalSurcharge =
          formData.captive === "3rd Party" ? AdditionalSurcharge : 0;
        WheelingLoss = Number(formData.voltage) <= 33 ? WheelingLoss : 0;
        WheelingCharges = Number(formData.voltage) <= 33 ? WheelingCharges : 0;
        let loss = 0;
        let WheeLoss = 0;
        if (TransmissionLoss) {
          loss = TransmissionLoss / 100;
        }
        if (WheelingLoss) {
          WheeLoss = WheelingLoss / 100;
        }

        total =
          loss * NonBusbar +
          TransmissionCharges +
          WheeLoss * NonBusbar +
          WheelingCharges +
          SOCCharges +
          Tax +
          BankingCharges +
          NonBusbar +
          SubsidySurcharge +
          AdditionalSurcharge;

        //  calculation[i].value = total.toString();
      } else if (cal.label === "Solar/Non-Peak DISCOM Landed (Rs./kWh)") {
        let NonPeak = Number(calList.field_solar_non_peak_grid_landed || 0);
        total = NonPeak;
        //calculation[i].value = NonPeak.toString();
      } else if (cal.label === "Evening/Peak DISCOM Landed (Rs./kWh)") {
        let Peak = Number(calList.field_evening_peak_grid_landed || 0);
        total = Peak;
        // calculation[i].value = Peak.toString();
      } else if (cal.label === "Solar / Non-Peak Savings (Rs./kWh)") {
        let NonPeakLanded = calculation.find(
          (f: any) => f.label === "Solar/Non-Peak DISCOM Landed (Rs./kWh)",
        );
        let PeakLanded = calculation.find(
          (f: any) => f.label === "Solar/Non-Peak OA Landed (Rs./kWh)",
        );

        total =
          Number(NonPeakLanded?.value || 0) - Number(PeakLanded?.value || 0);

        // calculation[i].value = total.toString();
      } else if (cal.label === "Evening / Peak Savings (Rs./kWh)") {
        let NonPeakLanded = calculation.find(
          (f: any) => f.label === "Evening/Peak DISCOM Landed (Rs./kWh)",
        );
        let PeakLanded = calculation.find(
          (f: any) => f.label === "Evening/Peak OA Landed (Rs./kWh)",
        );

        total =
          Number(NonPeakLanded?.value || 0) - Number(PeakLanded?.value || 0);

        // calculation[i].value = total.toString();
      }
      return {
        ...cal,
        value: total ? total.toFixed(2) : cal.value,
      };
    });
    //setCalculation(updated); // ✅ THIS TRIGGERS UI UPDATE

    const updatedAgain = updated.map((cal: any, i: any) => {
      let total = cal.value;
      if (cal.label === "Solar / Non-Peak Savings (Rs./kWh)") {
        let NonPeakLanded = updated.find(
          (f: any) => f.label === "Solar/Non-Peak DISCOM Landed (Rs./kWh)",
        );
        let PeakLanded = updated.find(
          (f: any) => f.label === "Solar/Non-Peak OA Landed (Rs./kWh)",
        );

        total =
          Number(NonPeakLanded?.value || 0) - Number(PeakLanded?.value || 0);

        // calculation[i].value = total.toString();
      } else if (cal.label === "Evening / Peak Savings (Rs./kWh)") {
        let NonPeakLanded = updated.find(
          (f: any) => f.label === "Evening/Peak DISCOM Landed (Rs./kWh)",
        );
        let PeakLanded = updated.find(
          (f: any) => f.label === "Evening/Peak OA Landed (Rs./kWh)",
        );

        total =
          Number(NonPeakLanded?.value || 0) - Number(PeakLanded?.value || 0);

        // calculation[i].value = total.toString();
      }
      return {
        ...cal,
        value: Number(total).toFixed(2),
      };
    });
    setCalculation(updatedAgain); // ✅ THIS TRIGGERS UI UPDATE
    setIsShow(true);
    // console.log("Total:",calculation);
  };

  const resetForm = () => {
    const updatedClear = calculation.map((cal: any, i: any) => {
      return {
        ...cal,
        value: "",
      };
    });
    setCalculation(updatedClear); // ✅ THIS TRIGGERS UI UPDATE
    setFormData({
      name: "",
      email: "",
      mobile: "",
      organization: "",
      state: "",
      captive: "",
      voltage: "",
      nonPeak: "",
      peak: "",
      nonBusbar: "",
      peakBusbar: "",
     
    });
    setErrors({
      name: "",
      email: "",
      mobile: "",
    });
    setErrorcal({
      state: "",
      captive: "",
      voltage: "",
          nonPeak: "",
    peak: "",
    nonBusbar: "",
    peakBusbar: "",
    });
    setSelectedVoltage(0);
    setIsShow(false);
    setIsShowState(false);
  };

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const reportNext = (no: number) => {
    if(no === 1){
    resetForm();
      const savedData = getSessionWithExpiry("userData");
        //console.log("Saved session data:", savedData);

        if (savedData) {
          setFormData((prev) => {
            const updated = { ...prev, ...savedData };
            //console.log("Updating formData to:", updated);
            return updated;
          });
        }
    }
    setIsShowDiv(no);
  };
  const setSessionWithExpiry = (key: string, value: any, ttl: number) => {
    const item = {
      value,
      expiry: Date.now() + ttl,
    };
    sessionStorage.setItem(key, JSON.stringify(item));
  };

  // const getSessionWithExpiry = (key: string) => {
  //   const itemStr = sessionStorage.getItem(key);
  //   if (!itemStr) return null;

  //   const item = JSON.parse(itemStr);

  //   if (Date.now() > item.expiry) {
  //     sessionStorage.removeItem(key);
  //     return null;
  //   }

  //   return item.value;
  // };
  
  const getSessionWithExpiry = (key: string) => {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);

      if (!item || !item.value) return null;

      if (Date.now() > item.expiry) {
        sessionStorage.removeItem(key);
        return null;
      }

      return item.value;
    } catch {
      return null;
    }
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrors({
      name: "",
      email: "",
      mobile: "",
    });

    const isValid = validateForm();

    if (!isValid) return;

    setLoading(true);

      const userData = {
        name: formData.name,
        mobile: formData.mobile,
        email: formData.email,
        organization: formData.organization
      
      };

    // store for 10 min
    setSessionWithExpiry("userData", userData, 10 * 60 * 1000);
    try {
      const payload = {
        webform_id: "calculation_form",
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        state: formData?.state,
        captive: formData.captive,
        voltage_level: formData.voltage,
        non_peak_annual: formData.nonPeak,
        peak_annual: formData.peak,
        non_peak_busbar: formData.nonBusbar,
        peak_busbar: formData.peakBusbar,
        organization: formData.organization,
        ismailsend:0
      };

      const response = await fetch(`${API_BASE_CMS}/webform_rest/submit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 200 || response.status === 201) {
        const respID = await response.json();   // ✅ IMPORTANT
       // console.log("Response:", respID);

        setSid(respID.sid); // ✅ GET SID HERE
        if(isState){
          setOpenState(true);
          resetForm();
          const savedData = getSessionWithExpiry("userData");
        //console.log("Saved session data:", savedData);

          if (savedData) {
            setFormData((prev) => {
              const updated = { ...prev, ...savedData };
              //console.log("Updating formData to:", updated);
              return updated;
            });
          }
        console.log(formData ,"formdata")
        }else{
          setIsShowDiv(3);
        }
      
        // setSuccess("Form submitted successfully!");
        //navigate('/thank-you');
        // setFormData({
        //   name: "",
        //   email: "",
        //   mobile: "",
        //   state: "",
        //   captive: "",
        //   voltage: "",
        //   nonPeak: "",
        //   peak: "",
        //   nonBusbar: "",
        //   peakBusbar: ""
        // });

        setErrors({
          name: "",
          email: "",
          mobile: "",
        });
      }
    } catch (err: any) {
      setError("Submission failed");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitUpdate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrors({
      name: "",
      email: "",
      mobile: "",
    });

    const isValid = validateForm();

    if (!isValid) return;

    setLoading(true);

    try {
      const DeleteSubmission = async (sId: string) => {
        const res = await fetch(
          `${API_BASE_CMS}/jsonapi/webform_submission/calculation_form/${sId}`,
          {
            method: "DELETE",
            headers: {
            //  "Authorization": "Basic " + btoa("admin:hrepl@123"),
              "Content-Type": "application/json",
            },
          }
        );

        if (!res.ok) {
          throw new Error(`Delete failed: ${res.status}`);
        }

        return true;
      };
     const deleteData = await DeleteSubmission(sId || ""); // ✅ NOW DEFINED
    if(deleteData){


      const payload = {
          webform_id: "calculation_form",
          name: formData.name,
          email: formData.email,
          mobile: formData.mobile,
          state: formData?.state,
          captive: formData.captive,
          voltage_level: formData.voltage,
          non_peak_annual: formData.nonPeak,
          peak_annual: formData.peak,
          non_peak_busbar: formData.nonBusbar,
          peak_busbar: formData.peakBusbar,
          organization: formData.organization,
          ismailsend:1
        };

        const response = await fetch(`${API_BASE_CMS}/webform_rest/submit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (response.status === 200 || response.status === 201) {
          setIsShowDiv(3);
          setErrors({
            name: "",
            email: "",
            mobile: "",
          });
        }
      }
    } catch (err: any) {
      setError("Submission failed");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const isReload = sessionStorage.getItem("isReload");

    if (isReload) {
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("isReload");
    } else {
      const savedData = getSessionWithExpiry("userData");

      if (savedData) {
        setFormData((prev) => ({
          ...prev,
          ...savedData,
        }));
      }
    }

    // mark reload
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("isReload", "true");
    });
  }, []);

// useEffect(() => {
 
//   // ✅ Normal load → restore session
//   const savedData = getSessionWithExpiry("userData");

//   if (savedData) {
//     setFormData((prev) => ({
//       ...prev,
//       ...savedData,
//     }));
//   }else
//   {
//      sessionStorage.removeItem("userData"); // ✅ clear session
//   }
// }, []);


useEffect(() => {
  if (!open) return;

  const timer = setTimeout(() => {
    handleClose();
  }, 3000);

  return () => clearTimeout(timer);
}, [open]);

useEffect(() => {
  if (!openState) return;

  const timer = setTimeout(() => {
  //  handleCloseState();
    setOpenState(false);
  }, 3000);
  // reportNext(1);
  return () => clearTimeout(timer);
}, [openState]);

const handleDecimalChange = (value:any, fieldName:any) => {
  // Allow numbers + optional decimal (2 digits)
  if (/^-?\d*\.?\d{0,2}$/.test(value)) {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  }
};

const handleDecimalBlur = (value:any, fieldName:any) => {
  if (value === '') return;

  // Remove trailing dot (e.g., "2." → "2")
  if (value.endsWith('.')) {
    value = value.slice(0, -1);
  }

  setFormData((prev) => ({
    ...prev,
    [fieldName]: value,
  }));
};
  if (!detail) return null;
  return (
    <div className="calculator-container">
      <div
        className={`container py-5 ${isShowDiv === 1 ? "d-block" : "d-none"}`}
      >
        <h2 className="text-center text-white mb-5">
          {detail?.data?.attributes?.field_solar_tariff_calculation_t?.[0]}
        </h2>

        <div className="row ">
          <div className="col-lg-6 col-12 border-end-custom px-4 px-md-5 px-lg-5">
            <div className="mb-4">
              <label className="form-label">
                {stateField.value} <span className="text-danger">*</span>
              </label>

              <select
                className="form-select custom-input"
                name="state"
                value={formData.state}
                onChange={handleChange}
              >
                <option value="">Select Your State</option>
                {data?.map((item: any, i: any) => (
                  <option value={item.title} key={i}>
                    {item.title}
                  </option>
                ))}
              </select>
              {errorcal.state && (
                <small className="text-danger error" id="nameError">
                  {errorcal.state}
                </small>
              )}
            </div>

            <div className="mb-4">
              <label className="form-label">
                {captiveField.value}
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select custom-input"
                name="captive"
                value={formData.captive}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                {detail?.data?.attributes?.field_cative_or_3rd_party.map(
                  (item: any, i: any) => (
                    <option value={item} key={i}>
                      {item}
                    </option>
                  ),
                )}
              </select>
              {errorcal.captive && (
                <small className="text-danger error" id="nameError">
                  {errorcal.captive}
                </small>
              )}
            </div>

            <div className="mb-5">
              <label className="form-label">
                {voltageField.value}
                <span className="text-danger">*</span>
              </label>
              {/* <input type="range" className="form-range custom-range" min="11" max="220" step="1" id="voltageRange" />
                    <div className="range-labels">
                        <span>11</span><span>22</span><span>33</span><span>66</span><span>110</span><span>132</span><span>220</span>
                    </div> */}
              <Box>
                <VoltageSliderMUI
                  // key={formData.voltage || 0} // 🔥 forces re-render
                  values={voltageLevels}
                  label="Voltage Level"
                  value={Number(formData?.voltage) ?? 0} // ✅ controlled value
                  defaultValue={0}
                  onChange={(val) => {
                    // console.log("Selected Voltage:", val);
                    setFormData((prev: any) => ({
                      ...(prev || {}), // ✅ prevents null crash
                      voltage: val,
                    }));
                    //(val);
                  }}
                />

                {/* <div style={{ color: "#fff", marginTop: "20px" }}>
                          Selected: {selectedVoltage} kV
                        </div> */}
              </Box>
              {errorcal.voltage && (
                <small className="text-danger error" id="nameError">
                  {errorcal.voltage}
                </small>
              )}
            </div>

            <div className={`input-group-custom ${errorcal.nonPeak ? 'mb-1' : 'mb-3'}`}>
              <label>{nonpeakField.value} <span className="text-danger">*</span></label>
              {/* <input
                type="number"
                name="nonPeak"
                value={formData.nonPeak}
                onChange={handleChange}
              /> */}
                <input
                type="text"
                name="nonPeak"
                value={formData.nonPeak}
                maxLength={12}
                onChange={(e) => handleDecimalChange(e.target.value, 'nonPeak')}
                onBlur={(e) => handleDecimalBlur(e.target.value, 'nonPeak')}
                //  onChange={(e) => {
                //     const value = e.target.value;

                //     if (/^\d*\.?\d{0,2}$/.test(value)) {
                //       setFormData((prev) => ({
                //         ...prev,
                //         nonPeak: value,
                //       }));
                //     }
                //   }}
                //   onBlur={(e) => {
                //     let value = e.target.value;

                //     if (value) {
                //       const num = parseFloat(value);
                //       if (!isNaN(num)) {
                //         setFormData((prev) => ({
                //           ...prev,
                //           nonPeak: num.toFixed(2),
                //         }));
                //       }
                //     }
                //   }}
              />
              
            </div>
 {errorcal.nonPeak && (
                <small className="text-danger error " id="nameError">
                  {errorcal.nonPeak}
                </small>
              )}
            <div className={`input-group-custom ${errorcal.peak ? 'mt-3' : 'mb-3'}`}>
              <label>{eveningpeakField.value} <span className="text-danger">*</span></label>
              {/* <input
                type="number"
                name="peak"
                value={formData.peak}
                onChange={handleChange}
              /> */}
               <input
                type="text"
                name="peak"
                value={formData.peak}
                maxLength={12}
                onChange={(e) => handleDecimalChange(e.target.value, 'peak')}
                onBlur={(e) => handleDecimalBlur(e.target.value, 'peak')}
              />
                
            </div>
{errorcal.peak && (
                <small className="text-danger error" id="nameError">
                  {errorcal.peak}
                </small>
              )}
            <div className={`input-group-custom ${errorcal.nonBusbar ? 'mt-3' : 'mb-3'}`}>
              <label>
                <>
                  {nonbusbarField.value}
                  <Tooltip title="Power supply through BESS" arrow>
                    <ErrorOutlineIcon sx={{ fontSize: 16 }} />
                  </Tooltip> <span className="text-danger">*</span>
                </>
              </label>
              {/* <input
                type="number"
                name="nonBusbar"
                value={formData.nonBusbar}
                onChange={handleChange}
                
              /> */}
               <input
                type="text"
                name="nonBusbar"
                value={formData.nonBusbar}
                maxLength={12}
                onChange={(e) => handleDecimalChange(e.target.value, 'nonBusbar')}
                onBlur={(e) => handleDecimalBlur(e.target.value, 'nonBusbar')}
              />
                
            </div>
 {errorcal.nonBusbar && (
                <small className="text-danger error  " id="nameError">
                  {errorcal.nonBusbar}
                </small>
              )}
            <div className={`input-group-custom ${errorcal.peakBusbar ? 'mt-3' : 'mb-4'}`}>
              <label>
                <>
                  {eveningbusbarField.value}
                  <Tooltip title="Power supply through BESS" arrow>
                    <ErrorOutlineIcon sx={{ fontSize: 16 }} />
                  </Tooltip> <span className="text-danger">*</span>
                </>
              </label>
             
                <input
                  type="text"
                  name="peakBusbar"
                  value={formData.peakBusbar}
                  maxLength={12}
                 onChange={(e) => handleDecimalChange(e.target.value, 'peakBusbar')}
                onBlur={(e) => handleDecimalBlur(e.target.value, 'peakBusbar')}
                />
                
            </div>
             {errorcal.peakBusbar && (
                <small className="text-danger error mb-3" id="nameError">
                  {errorcal.peakBusbar}
                </small>
              )}

            <div  className={`d-flex gap-3 justify-content-center ${errorcal.peakBusbar ? 'mt-3' : ''}`}>
              <button className="btn btn-sm btn-calculate" onClick={calculate}>
                {
                  detail?.data?.attributes
                    ?.field_solar_tariff_button_titles?.[0]
                }
              </button>
              <button className="btn btn-reset" onClick={resetForm}>
                {
                  detail?.data?.attributes
                    ?.field_solar_tariff_button_titles?.[1]
                }
              </button>
            </div>
          </div>

          <div className="col-lg-6 col-12  px-4 px-md-5 px-lg-5 mt-4 mt-md-0 mt-lg-0">
            <div className={`results-section ${isState ? "d-none" : "d-block"}`}>
              <h5 className="text-white mb-3">
                {" "}
                {
                  detail?.data?.attributes
                    ?.field_solar_tariff_calculation_t?.[1]
                }
              </h5>
              <div className="row g-3 mb-5">
                {calculation?.slice(0, 2).map((item: any, i: number) => (
                  <div className="col-md-6" key={i}>
                    <div
                      className={`result-card ${isShow && item.value > 0 ? "bg-success" : ""}  ${item.value < 0 ? "bg-danger" : ""}`}
                    >
                      <h2>{item.value || "--"}</h2>
                      <p>{item.label}</p>
                    </div>
                  </div>
                ))}
                <div className="col-md-6 d-none">
                  <div className="result-card">
                    <h2>--</h2>
                    <p>Evening/Peak OA Landed (Rs./kWh)</p>
                  </div>
                </div>
              </div>

              <h5 className="text-white mb-3">
                {
                  detail?.data?.attributes
                    ?.field_solar_tariff_calculation_t?.[2]
                }
              </h5>
              <div className="row g-3">
                {calculation?.slice(2, 4).map((item: any, i: number) => (
                  <div className="col-md-6" key={i}>
                    <div
                      className={`result-card ${isShow && item.value > 0 ? "grid-card-red" : ""} ${item.value < 0 ? "bg-danger" : ""}`}
                    >
                      <h2>{item.value || "--"}</h2>
                      <p>{item.label}</p>
                    </div>
                  </div>
                ))}
                <div className="col-md-6 d-none">
                  <div className="result-card">
                    <h2>--</h2>
                    <p>Evening/Peak Grid Tariff (Rs./kWh)</p>
                  </div>
                </div>
                <div className={`col-12 mt-5 cal-note`}>
                  <p className={` ${isShow ? "d-block" : "d-none"}`}>
                    {
                      detail?.data?.attributes
                        ?.field_solar_tariff_calculation_t?.[3]
                    }
                  </p>
                </div>
              </div>

              <div className="mt-lg-5 pt-4 text-center">
                <button
                  className={`btn btn-report ${isShow ? "" : "disabled"}`}
                  onClick={() => reportNext(2)}
                >
                  {
                    detail?.data?.attributes
                      ?.field_solar_tariff_button_titles?.[2]
                  }
                </button>
              </div>
            </div>
          <div className={`col-lg-12 cal-get-report ${isState ? "d-block" : "d-none"}`}>
            <form onSubmit={handleSubmit} >
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="name">
                      {NameField.value} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="name"
                      placeholder="Enter Your Name"
                      pattern="^[A-Za-z ]+$"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    <small className="text-danger error" id="nameError"></small>
                    {errors.name && (
                      <small className="text-danger error" id="nameError">
                        {errors.name}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="email">
                      {emailField.value} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Your email Id"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <small className="text-danger error" id="nameError">
                        {errors.email}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="organization">
                      {organizationField.value}{" "}
                    </label>
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control "
                        name="organization"
                        id="organization"
                        placeholder="Your Organization Name"
                        value={formData.organization}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="mobile">
                      {mobileField.value} <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex">
                      <input
                        type="tel"
                        className="form-control "
                        name="mobile"
                        id="mobile"
                        placeholder="Your Mobile Number"
                        pattern="[6-9][0-9]{9}"
                        title="Enter exactly 10 digits"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.mobile && (
                      <small className="text-danger error" id="nameError">
                        {errors.mobile}
                      </small>
                    )}
                  </div>
                </div>

                <div className="col-12 text-center">
                 
                  <button
                    type="submit"   
                    className="btn btn-sm btn-calculate-submit"
                      disabled={loading}
                  >
                  
                      {loading ? "Submitting..." : detail?.data?.attributes
                        ?.field_solar_tariff_button_titles?.[3] || "submit"}
                  </button>
              
                </div>
              </div>
            </form>
          </div>
          </div>
        </div>
      </div>
      <div
        className={`container py-5 cal-get-report ${isShowDiv === 2 ? "d-block" : "d-none"}`}
      >
        <h2 className="text-center text-white mb-5 ">
          {detail?.data?.attributes?.field_solar_tariff_calculation_t?.[4]}
        </h2>

        <div className="row ">
          <div className="col-lg-8 mx-auto  px-4 px-md-5 px-lg-5">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="name">
                      {NameField.value} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="name"
                      placeholder="Enter Your Name"
                      pattern="^[A-Za-z ]+$"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    <small className="text-danger error" id="nameError"></small>
                    {errors.name && (
                      <small className="text-danger error" id="nameError">
                        {errors.name}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="email">
                      {emailField.value} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Your email Id"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <small className="text-danger error" id="nameError">
                        {errors.email}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="organization">
                      {organizationField.value}{" "}
                    </label>
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control "
                        name="organization"
                        id="organization"
                        placeholder="Your Organization Name"
                        value={formData.organization}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="mobile">
                      {mobileField.value} <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex">
                      <input
                        type="tel"
                        className="form-control "
                        name="mobile"
                        id="mobile"
                        placeholder="Your Mobile Number"
                        pattern="[6-9][0-9]{9}"
                        title="Enter exactly 10 digits"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.mobile && (
                      <small className="text-danger error" id="nameError">
                        {errors.mobile}
                      </small>
                    )}
                  </div>
                </div>

                <div className="col-12 text-center">
                 
                  <button
                    type="submit"
                    className="btn btn-sm btn-calculate-submit"
                      disabled={loading}
                  >
                  
                      {loading ? "Submitting..." : detail?.data?.attributes
                        ?.field_solar_tariff_button_titles?.[3] || "submit"}
                  </button>
              
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className={`container py-5 cal-report-detail ${isShowDiv === 3 ? "d-block" : "d-none"}`}
      >
        <h2 className="text-center text-white mb-5">
          {" "}
          {detail?.data?.attributes?.field_solar_tariff_calculation_t?.[5]}
        </h2>

        <div className="row  ">
          <div className="col-lg-6 px-lg-5 border-end-custom px-4 px-md-0 px-lg-0">
            <h5 className="text-white mb-4">
              {" "}
              {detail?.data?.attributes?.field_solar_tariff_calculation_t?.[6]}
            </h5>
            <div className="data-table mb-4">
              <div className="d-flex justify-content-between">
                <span>Transmission Loss (%)</span>
                <span>{caldetail?.field_transmission_loss || 0}%</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Transmission Charges (Rs./kWh)</span>
                <span>{caldetail?.field_transmission_charges || 0}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Wheeling Loss (%)</span>
                <span>
                  {Number(formData.voltage) <= 33
                    ? caldetail?.field_wheeling_loss
                    : 0}
                  %
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Wheeling Charges (Rs./kWh)</span>
                <span>
                  {Number(formData.voltage) <= 33
                    ? caldetail?.field_wheeling_charges
                    : 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Scheduling / SOC Charges (Rs./kWh)</span>
                <span>{caldetail?.field_scheduling_soc_charges || 0}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Self-Generation Tax (Rs./kWh)</span>
                <span>{caldetail?.field_tax || 0}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Cross Subsidy Surcharge (Rs./kWh)</span>
                <span>
                  {formData.captive === "3rd Party"
                    ? caldetail?.field_cross_subsidy_surcharge
                    : 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Additional Surcharge (Rs./kWh)</span>
                <span>
                  {formData.captive === "3rd Party"
                    ? caldetail?.field_additional_surcharge
                    : 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Banking Charges (Rs./kWh)</span>
                <span>{caldetail?.field_banking_charges || 0}</span>
              </div>
            </div>

            <div className="row g-3">
              {calculation?.slice(0, 2).map((item: any, i: number) => (
              <div  key={i} className={`col-6  ${item.value < 0 ? "bg-danger" : ""}`}>
                  <div className={`oa-card text-center `}>
                    <h3>{item.value || "--"}</h3>
                    <p>{item.label}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="row mt-5 align-items-center">
              <div
                className="col-12 col-md-4 col-lg-4"
                dangerouslySetInnerHTML={{
                  __html:
                    detail?.data?.attributes?.field_solar_tariff_saving_title
                      ?.value || "",
                }}
              />
              {/* <h4 className="text-white mb-0"> Savings</h4>
                        <p className="text-white small opacity-75">(Grid Tariff - OA Landed)</p>
                    </div> */}
              {calculation?.slice(4, 6).map((item: any, i: number) => (
                <div className="col-6 col-md-4 col-lg-4" key={i}>
                  <div className={`savings-pill ${item.value < 0 ? "bg-danger" : ""}`}>
                    <span className="value">{item.value || "--"}</span>
                    <span className="label">{item.label}</span>
                  </div>
                </div>
              ))}
              <div className="col-4 d-none">
                <div className="savings-pill">
                  <span className="value">2.34</span>
                  <span className="label">Evening/Peak</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 px-lg-5 px-4 px-md-0 px-lg-0 mt-4 mt-md-0 mt-lg-0">
            <h5 className="text-white mb-4">
              {" "}
              {detail?.data?.attributes?.field_solar_tariff_calculation_t?.[7]}
            </h5>
            <div className="data-table mb-4">
              <div className="d-flex justify-content-between">
                <span>Solar/Non-Peak TOD Tariff (Rs./kWh)</span>
                <span>{caldetail?.field_solar_non_peak_tod_tariff || 0}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Evening/Peak TOD Tariff (Rs./kWh)</span>
                <span>{caldetail?.field_evening_peak_tod_tariff || 0}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>ToD Tariff — Net (Rs./kWh)</span>
                <span>{caldetail?.field_tod_tariff || 0}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Fuel Surcharges (Rs./kWh)</span>
                <span>{caldetail?.field_fuel_surcharges || 0}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Electrical Duty (%)</span>
                <span>{caldetail?.field_electrical_duty || 0}</span>
              </div>
            </div>

            <div className="row g-3 last-step-align">
              {calculation?.slice(2, 4).map((item: any, i: number) => (
                <div  key={i} className={`col-6  ${item.value < 0 ? "bg-danger" : ""}`}>
                  <div className="grid-card grid-card-red text-center">
                    <h3>{item.value || "--"}</h3>
                    <p>{item.label}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-5">
              <p className="small text-white opacity-75">
                {" "}
                {
                  detail?.data?.attributes
                    ?.field_solar_tariff_calculation_t?.[8]
                }
              </p>
                  <form onSubmit={handleSubmitUpdate}>
              <button
                className="btn btn-primary-dark px-4"
                type="submit"
                onClick={handleClickOpen}
              >
                {
                  detail?.data?.attributes
                    ?.field_solar_tariff_button_titles?.[4]
                }
              </button>
              </form>
            </div>
          </div>
        </div>

        <div className="text-center mt-5 pt-4 border-top-custom-div">
          <button
            className="btn btn-sm btn-calculate"
            onClick={() => reportNext(1)}
          >
            {detail?.data?.attributes?.field_solar_tariff_button_titles?.[5]}
          </button>
        </div>
      </div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" className="justify-content-between ">
                  <span></span> {/* optional title */}

  <IconButton
    aria-label="close"
    onClick={handleClose}
    sx={{
      position: "absolute",
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
    }}
  >
    <CloseIcon />
  </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="row justify-content-center mb-3">
              <div className="col-lg-12 ">
                <div className="text-center">
                  <div className="success-container">
                    <svg
                      className="checkmark-svg"
                      viewBox="0 0 100 100"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        className="main-circle"
                        cx="50"
                        cy="50"
                        r="25"
                        fill="#2ecc71"
                      ></circle>
                      <path
                        className="check"
                        d="M40 50 L47 57 L60 44"
                        fill="none"
                        stroke="white"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <circle
                        className="dot"
                        cx="50"
                        cy="15"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="75"
                        cy="25"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="85"
                        cy="50"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="75"
                        cy="75"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="50"
                        cy="85"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="25"
                        cy="75"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="15"
                        cy="50"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="25"
                        cy="25"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                    </svg>
                  </div>
                  <img
                    src="assets/img/thank-you-v.jpeg"
                    width="180px"
                    className="d-none"
                    alt="img-fluid"
                  />

                  <h1
                    style={{
                      fontSize: "40px",
                      fontWeight: "700",
                      marginBottom: "10px",
                      color: "#0d2a5c",
                    }}
                  >
                    Thank You!
                  </h1>

                  <p
                    style={{
                      marginTop: "6px",
                      fontSize: "15px",
                      color: "#64748b",
                    }}
                  >
                    We appreciate your time - we'll review and get back to you
                    soon.....
                  </p>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="justify-content-center d-none">
          <button
            className="btn btn-primary-dark text-center px-4 mb-3"
            onClick={handleClose}
          >
            Yes
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={openState}
        onClose={handleCloseState}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" className="justify-content-between ">
          <span></span> {/* optional title */}

  <IconButton
    aria-label="close"
    onClick={handleCloseState}
    sx={{
      position: "absolute",
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
    }}
  >
    <CloseIcon />
  </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="row justify-content-center mb-3">
              <div className="col-lg-12 ">
                <div className="text-center">
                  <div className="success-container">
                    <svg
                      className="checkmark-svg"
                      viewBox="0 0 100 100"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        className="main-circle"
                        cx="50"
                        cy="50"
                        r="25"
                        fill="#2ecc71"
                      ></circle>
                      <path
                        className="check"
                        d="M40 50 L47 57 L60 44"
                        fill="none"
                        stroke="white"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <circle
                        className="dot"
                        cx="50"
                        cy="15"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="75"
                        cy="25"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="85"
                        cy="50"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="75"
                        cy="75"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="50"
                        cy="85"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="25"
                        cy="75"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="15"
                        cy="50"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                      <circle
                        className="dot"
                        cx="25"
                        cy="25"
                        r="2"
                        fill="#2ecc71"
                      ></circle>
                    </svg>
                  </div>
                  <img
                    src="assets/img/thank-you-v.jpeg"
                    width="180px"
                    className="d-none"
                    alt="img-fluid"
                  />

                  <h1
                    style={{
                      fontSize: "40px",
                      fontWeight: "700",
                      marginBottom: "10px",
                      color: "#0d2a5c",
                    }}
                  >
                    Thank You!
                  </h1>

                  <p
                    style={{
                      marginTop: "6px",
                      fontSize: "14px",
                      color: "#64748b",
                    }}
                  >
                    We appreciate your time - we’ll get back to you soon
                  </p>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="justify-content-center d-none">
          <button
            className="btn btn-primary-dark text-center px-4 mb-3"
            onClick={handleCloseState}
          >
            Ok
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SolarCalculator;
